/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Addr_Sugg_SaveInputs */

const cs_addr_sugg_save = /** @type {(inputs: Addr_Sugg_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uložit`)
};

const en_addr_sugg_save = /** @type {(inputs: Addr_Sugg_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save`)
};

/**
* | output |
* | --- |
* | "Save" |
*
* @param {Addr_Sugg_SaveInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const addr_sugg_save = /** @type {((inputs?: Addr_Sugg_SaveInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addr_Sugg_SaveInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addr_sugg_save(inputs)
	return cs_addr_sugg_save(inputs)
});